import { useDispatch } from 'react-redux';

import useRefreshSession from '/shared/components/functional/useRefreshSession';
import type { LegacyDispatch } from '/business/shared/state/actions/types';

export function SessionRefresh() {
  const dispatch = useDispatch<LegacyDispatch>();

  useRefreshSession(dispatch);

  return null;
}

export default SessionRefresh;
